import { GetServerSideProps } from "next/types";
import { useMemo, useState } from "react";
import { Trans, useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Col, Container, Row } from "reactstrap";
import { Card, Layout } from "../../../components/_organisms";
import { User } from "../../../services/auth";
import Register from "./Signup";
import Verify from "./SignupVerify";
import withRouteProtection from "../../../components/withRouteProtection";
import styles from "./Signup.module.scss";
import { Logo } from "../../../components/_atoms";
import {
  LogoColors,
  LogoTextColors,
} from "../../../components/_atoms/Logo/Logo";

const Signup: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);

  const { t } = useTranslation("auth");

  const currentFormStep = useMemo(
    () => (!user ? <Register setUser={setUser} /> : <Verify user={user} />),
    [user],
  );

  return (
    <Layout title={t("signup.title")} wide className="p-0">
      <Container fluid="xxl">
        <Row className="gx-0 my-8 my-md-12 align-items-center">
          <Col xs="12">
            <Card>
              <Row>
                <Col md={6} className="border-end">
                  <div className="p-6">
                    <Logo
                      color={LogoColors.Green}
                      textColor={LogoTextColors.Black}
                      style={{ width: "12rem" }}
                      className="m-auto mb-8"
                    />
                    <h1 className="mb-8">{t("claim.title")}</h1>
                    <ol className={styles.list}>
                      {(t("claim.steps", { returnObjects: true }) as [])?.map(
                        (text, i) => (
                          <li key={i}>{text}</li>
                        ),
                      )}
                    </ol>
                    <Trans
                      i18nKey="claim.description"
                      t={t}
                      components={[<div key={2} />, <sub key={1}></sub>]}
                    />
                  </div>
                </Col>
                <Col xs="12" md="6">
                  <div className="p-6">{currentFormStep}</div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? "de", ["auth", "common"])),
  },
});

export default withRouteProtection(Signup);
